(function($) {
  "use strict"

  $(document).ready(function() {

    var $id = "#mainNavbar";
    var $navbar = $($id);
    var $offcanvas = $navbar.find(".offcanvas-collapse");

    if ($offcanvas.length) {

      // Open / Close when clicking toggle
      $navbar.find(".navbar-toggler").on("click", function() {
        $offcanvas.toggleClass("open");
        $(".offcanvas-overlay").toggleClass("show");
        $("body").toggleClass("no-scrolling");
      });

      // Change offset on resize
      $(window).on("resize", function() {
        $offcanvas.css({
          "top": $navbar.outerHeight(),
        });
      }).resize();

      $(".offcanvas-overlay").on("click", function() {
        $offcanvas.removeClass("open");
        $(".offcanvas-overlay").removeClass("show");
        $(".hamburger").removeClass("is-active");
        $("body").removeClass("no-scrolling");
      });

    }

  });

})(jQuery);